import React, { FC } from "react";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  main: {
    fontSize: 16,
    fontWeight: "normal",
    letterSpacing: 0,
    lineHeight: "20px",
    margin: "10px 0 28px",
  },
  spacer: {
    height: 58,
    [theme.breakpoints.down("sm")]: {
      height: 38,
    },
  },
}));

interface Props {
  title: string;
}

const NoMemoSubTitle: FC<Props> = (props: Props) => {
  const classes = useStyles();
  if (props.title === "") {
    return <div className={classes.spacer} />;
  }
  return (
    <Typography variant={"subtitle1"} data-test="subtitle">
      {props.title}
    </Typography>
  );
};

export const SubTitle = React.memo(NoMemoSubTitle);
